var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadminton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON_Badminton") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON_Badminton",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_badminton_2276027_000000",
    transform: "translate(28.459614, 27.626202) rotate(-30.000000) translate(-28.459614, -27.626202) translate(7.959614, 7.206974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5932667,29.8384573 L13.5948753,32.4780349 L27.5916582,32.4780349 L27.5932667,29.8384573 L13.5932667,29.8384573 Z M13.6463539,34.2395131 C14.0565591,37.946272 17.0164866,40.8384573 20.594092,40.8384573 C24.1701325,40.8384573 27.1300147,37.946272 27.5401829,34.2395131 L13.6463539,34.2395131 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4860497,5.68434189e-14 C20.2594486,0.00348528039 20.0447809,0.0975940969 19.8846209,0.261413875 L14.5873884,5.6744844 L16.5671881,23.096871 C16.6046709,23.3373697 16.5433355,23.5830792 16.4002195,23.7765275 C16.2553994,23.9699712 16.040723,24.0954494 15.8055948,24.1233334 C15.5687699,24.1512174 15.3319625,24.0797647 15.1496452,23.9246608 C14.9656356,23.7695542 14.8531877,23.5447421 14.8361511,23.3007724 L12.7677661,5.10477133 L8.0314427,0.261873404 C7.86447411,0.0910848494 7.63616753,-0.00302485932 7.40105241,0.000459528776 C7.17445124,0.0056878955 6.95808252,0.0980536256 6.79962352,0.261873404 L0.257137932,6.95404005 C-0.0273904046,7.24333795 -0.0819111178,7.69294447 0.124242603,8.04325709 L12.4188815,29 L28.5827464,29 L40.8756407,8.04325709 C41.0817987,7.69296232 41.027278,7.2433201 40.7444507,6.95404005 L34.2019651,0.261873404 C33.8612107,-0.0866769423 33.3091776,-0.0866769423 32.9684449,0.261873404 L28.1793455,5.16410854 L25.2863456,23.3444946 C25.2522701,23.5797644 25.1261899,23.792379 24.9370728,23.9317991 C24.7479557,24.0729637 24.5128319,24.1304717 24.2828242,24.0921345 C24.0528166,24.0520511 23.8466585,23.921346 23.7120578,23.7261578 C23.5774614,23.532714 23.5246418,23.290471 23.5655323,23.0552011 L26.3409855,5.60336898 L21.1170289,0.261681561 C20.9500603,0.0908930073 20.7234591,-0.00321670143 20.4866386,5.68434189e-14 L20.4860497,5.68434189e-14 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadminton);
export default ForwardRef;